// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("@expln/utils/src/main/Expln_React_Row.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var TextField = require("@mui/material/TextField").default;
var Save = require("@mui/icons-material/Save").default;
var IconButton = require("@mui/material/IconButton").default;

function makeInitialState(param) {
  return {
          newText: ""
        };
}

function setNewText(st, text) {
  return {
          newText: text
        };
}

function rndIconButton(icon, onClick, active, title, param) {
  var tmp = {};
  if (title !== undefined) {
    tmp.title = Caml_option.valFromOption(title);
  }
  return React.createElement("span", tmp, React.createElement(IconButton, {
                  onClick: (function (param) {
                      Curry._1(onClick, undefined);
                    }),
                  color: "primary",
                  disabled: !active,
                  children: icon
                }));
}

function MM_cmp_multiline_text(Props) {
  var text = Props.text;
  var editMode = Props.editMode;
  var onEditRequested = Props.onEditRequested;
  var onEditDone = Props.onEditDone;
  var match = React.useState(function () {
        return {
                newText: ""
              };
      });
  var setState = match[1];
  var state = match[0];
  React.useEffect((function () {
          if (editMode) {
            Curry._1(setState, (function (__x) {
                    return {
                            newText: text
                          };
                  }));
          }
          
        }), [editMode]);
  var actNewTextUpdated = function (newText) {
    Curry._1(setState, (function (__x) {
            return {
                    newText: newText
                  };
          }));
  };
  var actEditDone = function (param) {
    Curry._1(onEditDone, state.newText);
  };
  if (editMode) {
    return React.createElement(Expln_React_Row.make, {
                children: null
              }, React.createElement(TextField, {
                    value: state.newText,
                    size: "small",
                    style: {
                      width: "600px"
                    },
                    multiline: true,
                    onChange: (function (param) {
                        return Expln_React_common.evt2str(actNewTextUpdated, param);
                      }),
                    onKeyDown: (function (__x) {
                        if (__x.ctrlKey && __x.keyCode === 13) {
                          return Curry._1(actEditDone, undefined);
                        }
                        
                      }),
                    autoFocus: true,
                    title: "Ctrl+Enter to save"
                  }), rndIconButton(React.createElement(Save, {}), actEditDone, true, "Save, Ctrl+Enter", undefined));
  }
  var style = text.trim() === "" ? ({
        padding: "4px"
      }) : ({
        padding: "0px"
      });
  return React.createElement(Paper, {
              onClick: (function (__x) {
                  if (__x.button === 0 && __x.altKey) {
                    return Curry._1(onEditRequested, undefined);
                  }
                  
                }),
              style: style,
              variant: "outlined",
              title: "Alt+<left-click> to change",
              children: React.createElement("pre", undefined, text)
            });
}

var make = MM_cmp_multiline_text;

exports.makeInitialState = makeInitialState;
exports.setNewText = setNewText;
exports.rndIconButton = rndIconButton;
exports.make = make;
/* react Not a pure module */
